<template>
    <div class="d-flex align-center">
        <div>
            <router-link
                v-if="item.userProfile"
                class="dd-name-link"
                :to="
                    getIdFromIri(
                        item.userProfile,
                        '@id',
                        routeType.USER_EDIT,
                        'userId'
                    )
                "
            >
                {{ item.userProfile | toFullName }}
            </router-link>
            <template v-else>
                {{ item.deliveryName }}
            </template>
            <!-- the delivery city only when it is not London, the usual one (tasks#211) -->
            <status-badge v-if="otherCity" class="ml-1">{{
                otherCity
            }}</status-badge>
            <small
                v-if="
                    !isCompanyAdmin &&
                    item.companyName &&
                    (item.companyName !== item.deliveryName || item.userProfile)
                "
                class="d-flex g-73--text"
            >
                {{ item.companyName }}
            </small>
            <small v-if="!item.userProfile" class="d-flex g-73--text">
                {{
                    $t('orders.canteen_details', {
                        portion: meals,
                        customer: customers,
                    })
                }}
            </small>
        </div>
    </div>
</template>

<script>
import routeType from '@/router/routeType'
import { getIdFromIri } from '@/services/IdFromIri'
import AuthMixin from '@/components/mixins/AuthMixin'
import { mapGetters } from 'vuex'
import authType from '@/store/type/authType'
import { ROLE_COMPANY } from '@/enum/roles'
import StatusBadge from '@/components/elements/StatusBadge.vue'

export default {
    components: { StatusBadge },
    mixins: [AuthMixin],
    props: {
        item: null,
    },
    data() {
        return {
            routeType,
        }
    },
    computed: {
        ...mapGetters({
            userRoles: authType.getters.GET_ROLES,
        }),
        otherCity() {
            const city = String(
                this.item?.deliveryAddressDetails?.city || ''
            ).trim()
            return this.isSuperAdmin && city && city.toLowerCase() !== 'london'
                ? city
                : null
        },
        isCompanyAdmin() {
            return this.userRoles.indexOf(ROLE_COMPANY) !== -1
        },
        customers() {
            return this.item?.canteenSubOrdersByCutoff?.reduce(
                (acc, cutoff) => acc + cutoff.orderIds.length,
                0
            )
        },
        meals() {
            return this.item?.canteenSubOrdersByCutoff?.reduce(
                (acc, cutoff) => acc + cutoff.mealsQuantity,
                0
            )
        },
    },
    methods: {
        getIdFromIri,
    },
}
</script>
